/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import { useServiceService } from 'domain/shared/service';
import { useServiceUrl } from 'domain/shared/service';
import UpdateServiceBreadcrumbs from 'domain/organization/service/createupdate/Update/Breadcrumbs';
import ServiceEntityHeader from 'domain/organization/service/shared/ServiceEntityHeader';
import ServiceForm from 'domain/organization/service/createupdate/ServiceForm';
import { useEmployeeService } from 'domain/shared/employee';

const UpdateService = () => {
  const { update, getById, getValidationSchema } = useServiceService();
  const { getSingleEntityUrl } = useServiceUrl();
  const { getById: getEmployeeById } = useEmployeeService();

  const getDataMethod = async (id: string) => {
    const { rbsTreeNode, ...data } = await getById(id);

    return {
      ...data,
      name: data.name,
      rbsTreeNodeName: rbsTreeNode?.name,
      rbsTreeNodeId: rbsTreeNode?.id,
      redmineAlias: rbsTreeNode?.attributes.alias,
      staffingCoordinator: await getEmployeeById(data.staffingCoordinatorAlias),
    };
  };

  return (
    <UpdateForm
      submitFormFunc={update}
      getDataFunc={getDataMethod}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Service has been successfully saved.',
      }}
    >
      <UpdatePageLayout
        title="Edit: Service"
        breadcrumbs={<UpdateServiceBreadcrumbs />}
        entityHeader={<ServiceEntityHeader />}
      >
        <ServiceForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateService;
